import { OrganizationGroupInvitation } from "../../../model/OrganizationGroupInvitation";

/*
 * Invitations of mock org 2, "very big american corporation".
 */

export const ORG_2_INVITATIONS: OrganizationGroupInvitation[] = [];
